import React, { useEffect, useRef, useState } from 'react';
import logo from '../../assets/d97ae9ac8355a0d5876385dc4a41e6c7af024c07.jpg';
import './inivation.css';
import baby from "../../assets/inivitation/beautiful-baby-shower-concept-with-copy-space.jpg";
import Navbar from '../navbar/Navbar';
import axios from "axios";
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Navigate, useNavigate } from 'react-router-dom';


function Invitation() {
  const headerRef = useRef(null);

  const navigate = useNavigate();

  const [show, setShow] = useState(false);
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [selectedInvitation, setSelectedInvitation] = useState('');


  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

    useEffect(() => {
      AOS.init({
        duration: 1000,
        once: true,
      });
  
      setTimeout(() => {
        AOS.refresh();
      }, 500);
    }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = {
      email,
      name,
      phone,
      invitationType: selectedInvitation,
    };

    try {
      const response = await axios.post('https://electiaa.com/php/invitation.php', formData);
      alert(response.data.message);
        navigate('/thankyou');

      setEmail('');
      setName('');
      setPhone('');
      setSelectedInvitation('');
   
    } catch (error) {
      console.error('Error sending mail:', error);
      alert('Failed to send enquiry. Try again later.');
    }
  };


  const designData = [
    { name: 'WEDDING CARD', image: require('../../assets/inivitation/photorealistic-wedding-venue-with-intricate-decor-ornaments.jpg') },
    { name: 'ENGAGEMENT CARD', image: require('../../assets/inivitation/martini-glasses-make-pyramid-glass-table.jpg') },
    { name: 'BIRTHDAY CARD', image: require('../../assets/inivitation/birthday-background-invitation.jpg') },
    { name: 'CORPORATE PARTY CARD', image: require('../../assets/inivitation/flat-lay-party-still-life.jpg') },
    { name: 'PARTY CARD', image: require('../../assets/inivitation/closeup-groom-putting-ring-finger-bride-lights.jpg') },
    { name: 'BABY SHOWER CARD', image: baby },
    { name: 'POOJA CARD', image: require('../../assets/inivitation/diwali-celebration-illustration.jpg') },
    { name: 'RECEPTION CARD', image: require('../../assets/inivitation/hands-indian-bride-groom-intertwined-together-making-authentic-wedding-ritual.jpg') },
    { name: 'HOUSE WARMING CARD', image: require('../../assets/inivitation/HOUSE WARMING CARDS.jpg') },
    { name: 'SAVE THE DATE CARD', image: require('../../assets/inivitation/81131.jpg') },
  ];



  return (
    <>
      <Navbar />
      <div className="container-fluid web-container" >
        <div className="wrapper">
          <section className='section-margin'>
            <center>
              <div className='heading-for-all' data-aos="fade-up">
                <h2>e-invitation</h2>
              </div>
            </center>
          </section>


          <section>
            <div className='container-fluid design-main-container py-5'>
              <div className='container'>
                <div className='row g-4 d-flex justify-content-center'>
                  {designData.map((item, index) => (
                    <div className="col-12 col-sm-6 col-md-4 col-lg-3 container-details" key={index}
                    data-aos="fade-up" data-aos-delay="1000">

                      <div className='flip-card'>
                        <div className='flip-card-inner'>
                          <div className='flip-card-front'>
                            <img src={item.image} alt='design' className='img-fluid' />
                            <h4>{item.name}</h4>
                          </div>
                          <div className='flip-card-back'>
                            <p style={{ fontFamily: "Lora" }}>{item.name}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

             <div
                    className="container d-flex justify-content-center my-4"
                    data-aos="fade-up"
                    data-aos-delay="1000"
                >
                    <button className="btn-15" onClick={handleShow}>
                        Get Enquiry
                    </button>
                </div>

            {show && (
              <div className="popup-backdrop">
                <div className="wrapper-1 popup-card">
                  <button
                    className="btn-close-popup"
                    onClick={handleClose}
                    aria-label="Close"
                  >
                    &times;
                  </button>
                  <form onSubmit={handleSubmit}>
                    <h2>Get Enquiry</h2>

                    <div className="input-field">
                      <input
                        type="text"
                        required
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                      <label>Enter your Email</label>
                    </div>

                    <div className="input-field">
                      <input
                        type="text"
                        required
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                      />
                      <label>Enter your Name</label>
                    </div>

                    <div className="input-field">
                      <input
                        type="text"
                        required
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                      />
                      <label>Enter your Phone Number</label>
                    </div>

                    <div className="input-field">
                      <select
                        value={selectedInvitation}
                        onChange={(e) => setSelectedInvitation(e.target.value)}
                        required
                      >
                        <option value="" disabled>Select Invitation Type</option>
                        {designData.map((item, idx) => (
                          <option key={idx} value={item.name}>
                            {item.name}
                          </option>
                        ))}
                      </select>
                    </div>

                    <button type="submit">Submit</button>
                  </form>
                </div>
              </div>
            )}

          </section>
        </div>
      </div>

    </>
  );
}

export default Invitation;
